import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;
  readonly toasts = signal<Toast[]>([]);

  showSuccess(message: string) { this.push('success', message); }
  showError(message: string)   { this.push('error', message); }
  showInfo(message: string)    { this.push('info', message); }
  showWarning(message: string) { this.push('warning', message); }

  dismiss(id: number) {
    this.toasts.set(this.toasts().filter(t => t.id !== id));
  }

  private push(type: Toast['type'], message: string) {
    const id = this.nextId++;
    this.toasts.set([...this.toasts(), { id, type, message }]);
    setTimeout(() => this.dismiss(id), 4000);
  }
}
